const showResults = (data) => {
  return Array.isArray(data) && data.length > 0;
};
const showNoResults = (data) => {
  return Array.isArray(data) && data.length === 0;
};

export { showNoResults, showResults };
